import { useRhythmicLogger } from '#imports'

const logger = useRhythmicLogger('auth.global.middleware')

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const { sessionClaims, isLoaded, isSignedIn, getToken } = useAuth()
  const skippableRoutes = ['workspace-provision', 'index', 'team-provision']

  const { workspace: workspaceSlug, teamSlug } = to.params as {
    workspace: string
    teamSlug: string
  }

  if (skippableRoutes.includes(to.name as string)) return

  // Wait for session and user to load (max 3s)
  await until(() => isLoaded.value).toBeTruthy({ timeout: 3000 })

  // Require user to be authenticated (but not for the home page)
  if (!isSignedIn.value) {
    return navigateTo({ path: '/', query: { redirect_url: to.fullPath } })
  }

  const decodeTokenSlug = (token: string | null) => {
    if (!token) return null

    const parts = token.split('.')
    if (parts.length < 2) return null

    try {
      const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
      const payload = JSON.parse(atob(base64)) as { o?: { slg?: unknown } }
      const slug = payload?.o?.slg
      return typeof slug === 'string' && slug.length > 0 ? slug : null
    } catch (error) {
      logger.warn('Failed to decode Clerk token payload', { error })
      return null
    }
  }

  const resolveTokenSlug = () => {
    const claims = sessionClaims.value
    if (!claims || typeof claims !== 'object') return null

    const orgClaim = (claims as { o?: unknown }).o
    if (!orgClaim || typeof orgClaim !== 'object') return null

    const slug = (orgClaim as { slg?: unknown }).slg
    return typeof slug === 'string' && slug.length > 0 ? slug : null
  }

  let tokenSlug = resolveTokenSlug()

  if (!tokenSlug) {
    const resolveToken = getToken.value
    if (typeof resolveToken === 'function') {
      try {
        const token = await resolveToken()
        tokenSlug = decodeTokenSlug(token)
      } catch (error) {
        logger.warn('Failed to refresh Clerk token in middleware', { error })
      }
    }
  }

  if (!tokenSlug) {
    logger.warn('Missing organization slug in Clerk session claims', {
      claims: sessionClaims.value,
    })
    return
  }

  if (tokenSlug !== workspaceSlug) {
    logger.info('Mismatched workspace slug in token. Redirecting to correct workspace:', { tokenSlug, workspaceSlug })
    return navigateTo({
      name: to.name as string,
      params: { ...to.params, workspace: tokenSlug },
    })
  }
  // const { organization } = useOrganization()
  // if (organization?.value?.slug !== workspaceSlug) {
  //   // // Check the user has access to the workspaceSlug and then change their organization
  //   // if (
  //   //   user.value?.organizationMemberships.findIndex(
  //   //     membership => membership.organization?.slug === workspaceSlug,
  //   //   ) === -1
  //   // ) {
  //   //   return navigateTo({ name: 'workspace-provision', params: { workspace: workspaceSlug } })
  //   // }

  //   user.value?.organizationMemberships?.forEach((membership) => {
  //     if (membership.organization?.slug === workspaceSlug) {
  //       clerk.value!.setActive({ organization: membership.organization.id })
  //     }
  //   })
  // }

  if (to.name === 'team-dashboard') {
    return navigateTo({
      name: 'plans',
      params: { workspace: workspaceSlug, teamSlug },
    })
  }
})
